import { Injectable } from '@angular/core';
import { SomeNavigationService } from '../services/some-navigation.service';

/**
 * 戻るボタン押下により遷移してきた場合、遷移処理をキャンセルする。
 * @export
 * @class BrowserBackGuard
 * @implements {CanDeactivate}
 */
@Injectable({
  providedIn: 'root'
})
export class BrowserBackGuard {
  /**
   * コンストラクタ
   * @param {SomeNavigationService} someNavigationService
   * @memberof BrowserBackGuard
   */
  constructor(private someNavigationService: SomeNavigationService) { }

  /**
   * ブラウザの戻るボタンによる画面遷移ガード処理
   *
   * @param {*} component
   * @return {*} 
   * @memberof BrowserBackGuard
   */
  canDeactivate(component: any) {
    // 戻るボタン押下により遷移してきた場合、戻る処理をキャンセルする
    if (this.someNavigationService.backClicked) {
      this.someNavigationService.backClicked = false;
      history.pushState(null, null, location.href);
      return false;
    }
    return true;
  }
}
